import * as r from "react";
import { g as c, c as p } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { L as f } from "./ListItemText-C34sqqNp.mjs";
import { g as u } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as I } from "./jsx-runtime-3tyXYecC.mjs";
import { s as x, u as g, c as v } from "./DefaultPropsProvider-CFfEbxdP.mjs";
function L(t) {
  return c("MuiListItemAvatar", t);
}
u("MuiListItemAvatar", ["root", "alignItemsFlexStart"]);
const A = (t) => {
  const {
    alignItems: s,
    classes: e
  } = t;
  return v({
    root: ["root", s === "flex-start" && "alignItemsFlexStart"]
  }, L, e);
}, C = x("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (t, s) => {
    const {
      ownerState: e
    } = t;
    return [s.root, e.alignItems === "flex-start" && s.alignItemsFlexStart];
  }
})({
  minWidth: 56,
  flexShrink: 0,
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}), M = /* @__PURE__ */ r.forwardRef(function(s, e) {
  const a = g({
    props: s,
    name: "MuiListItemAvatar"
  }), {
    className: i,
    ...n
  } = a, m = r.useContext(f), o = {
    ...a,
    alignItems: m.alignItems
  }, l = A(o);
  return /* @__PURE__ */ I.jsx(C, {
    className: p(l.root, i),
    ownerState: o,
    ref: e,
    ...n
  });
});
export {
  M as L
};
//# sourceMappingURL=ListItemAvatar-DT4cgzXB.mjs.map
